/**
 * @file pages-privacy-policy.tsx
 * @module app/modules/setting/pages-privacy-policy
 * @description Privacy Policy sub-tab rendered inside the Pages tab of the
 * new Setting module. Copied from the deprecated
 * app/modules/settings/privacy-policy.tsx.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.9
 * @version 1.3.3
 */

import { appSettings } from '../../../api/apiEndPoints';
import { appSettingsToast } from '../../../utils/toast';
import { Privacy_Policy } from '../../../utils/constants';
import PageContentEditor from './components/page-content-editor';
import usePageContentEditor from './hooks/use-page-content-editor';

/**
 * Privacy Policy sub-tab component.
 * @returns {JSX.Element} Privacy policy editor content.
 */
const PagesPrivacyPolicy = () => {
  const editor = usePageContentEditor({
    permissionModule: Privacy_Policy,
    fetchEndpoint: appSettings.privacyPolicy,
    saveEndpoint: appSettings.addPrivacyPOlicy,
    successToast: appSettingsToast.addPrivacyPolicy,
  });

  return (
    <PageContentEditor
      title="Add / Edit privacy Policy"
      contentData={editor.contentData}
      loading={editor.loading}
      fetchLoading={editor.fetchLoading}
      selectedLanguage={editor.selectedLanguage}
      hasViewPermission={editor.hasViewPermission}
      onDataChange={editor.handleDataChange}
      onLanguageChange={editor.handleLanguageChange}
      onSave={editor.handleSave}
    />
  );
};
export default PagesPrivacyPolicy;
